import { useContext } from 'preact/hooks';

import type { TemplateFunction, TemplateFunctionInvoker, TemplateResult } from 'Components/types';

import VehicleWidget from '../../vehicleWidget/index';
import type { VehicleWidgetTemplateParams } from '../../vehicleWidget/vehicleWidget';
import { vehicleWidgetName } from '../garage';
import GarageContext from '../garageContext';

interface Props {
  template: TemplateFunction<VehicleDropdownsTemplateParams>;
}

export interface VehicleDropdownsTemplateParams {
  vehicleWidget: TemplateFunctionInvoker<VehicleWidgetTemplateParams>;
  template: 'vehicleDropdowns';
}

export default function VehicleDropdowns({ template }: Props): TemplateResult {
  const {
    closeGarage,
    doNotRedirectOnVehicleSelect,
    columnBreakpoint,
    isAutoVehicleSelectionDisabled,
    redirectUrl,
    useNativeDropdown,
  } = useContext(GarageContext);

  const vehicleWidget = (templ: TemplateFunction<VehicleWidgetTemplateParams>) => {
    const props = {
      isAlwaysActive: true,
      isAlwaysColumnLayout: true,
      isAutoVehicleSelectionDisabled,
      columnBreakpoint: typeof columnBreakpoint === 'string' ? undefined : columnBreakpoint,
      name: vehicleWidgetName,
      onSelectVehicle: () => closeGarage?.(),
      doNotRedirectOnVehicleSelect,
      redirectUrl,
      useNativeDropdown,
      template: templ,
    };
    return <VehicleWidget {...props} key={vehicleWidgetName} />;
  };

  return template.call({ vehicleWidget, template: 'vehicleDropdowns' });
}
